{
    "translation": {
        "welcome": "Bienvenue",
        "home": "Accueil",
        "find_pro": "Trouver un pro",
        "admin": "Admin",
        "my_space": "Mon Espace",
        "login": "Connexion",
        "logout": "Déconnexion",
        "search_placeholder": "Coiffeur, Barbier, Manucure...",
        "hero_title": "Réservez votre rendez-vous beauté",
        "hero_subtitle": "Trouvez les meilleurs professionnels près de chez vous.",
        "search_btn": "Rechercher",
        "popular_services": "Prestations Populaires",
        "footer_rights": "Tous droits réservés.",
        "legal_mentions": "Mentions Légales",
        "cgp": "Conditions Générales de Prestation",
        "feature_search_title": "Recherchez",
        "feature_search_desc": "Trouvez les meilleurs salons et experts près de chez vous",
        "feature_book_title": "Réservez",
        "feature_book_desc": "Choisissez votre créneau idéal en quelques secondes",
        "feature_enjoy_title": "Profitez",
        "feature_enjoy_desc": "Vivez une expérience beauté unique et relaxante",
        "featured_pros_title": "Professionnels à la une",
        "reviews_count": "avis",
        "client_space": "ESPACE CLIENT",
        "my_bookings": "Mes Réservations",
        "explore_map": "Salons à proximité",
        "edit_photo": "Modifier la photo",
        "photo_updated": "Photo de profil mise à jour !",
        "error_upload": "Erreur lors du téléchargement.",
        "hero_welcome": "Bienvenue sur OpenGlow",
        "hero_slogan": "L'excellence à portée de main.",
        "hero_desc": "Réservez vos soins de beauté et bien-être en quelques clics. Simple, rapide et élégant.",
        "i_am_pro": "Je suis un professionnel",
        "featured_pros_desc": "Découvrez nos experts recommandés pour des prestations d'excellence",
        "verified_reviews": "avis vérifiés",
        "book_verb": "Réserver",
        "default_location": "Paris, France",
        "login_title": "Connexion",
        "email_label": "Email",
        "password_label": "Mot de passe",
        "login_btn": "Se connecter",
        "no_account": "Pas encore de compte ?",
        "register_link": "S'inscrire",
        "register_title": "Inscription",
        "client_role": "Client",
        "pro_role": "Professionnel",
        "firstname_label": "Prénom",
        "lastname_label": "Nom",
        "birthdate_label": "Date de naissance",
        "profession_label": "Profession",
        "company_label": "Nom de l'entreprise",
        "siret_label": "SIRET",
        "register_btn": "S'inscrire",
        "already_account": "Vous avez déjà un compte ?",
        "login_link": "Se connecter",
        "login_error": "Erreur de connexion",
        "register_error": "Erreur lors de l'inscription",
        "generic_error": "Une erreur est survenue.",
        "search_title": "Trouvez votre professionnel de beauté",
        "search_placeholder": "Rechercher un salon, une adresse, une spécialité ou une prestation...",
        "search_action": "Rechercher",
        "filters_all": "Tous",
        "filter_sort": "Filtres",
        "filter_distance_nearest": "Distance: plus proche",
        "filter_rating_highest": "Note: meilleure",
        "filter_reviews_most": "Avis: plus nombreux",
        "filter_name_az": "Nom: A-Z",
        "filter_min_rating": "Note minimale",
        "filter_max_distance": "Distance max",
        "show_filters": "Afficher les filtres",
        "hide_filters": "Masquer les filtres",
        "map_style": "Style",
        "map_enable_location_filter": "Active la localisation pour le filtre distance",
        "results_label": "résultat(s)",
        "available_pros": "Professionnels disponibles",
        "view_profile": "Voir le profil",
        "no_results_title": "Aucun professionnel trouvé",
        "no_results_desc": "Essayez de modifier vos critères de recherche",
        "loading": "Chargement...",
        "profession_hairdresser": "Coiffeur",
        "profession_esthetician": "Esthéticien",
        "profession_barber": "Barbier",
        "profession_manicure": "Manucure",
        "profession_masseur": "Masseur",
        "bookings_title_client": "Mes Réservations",
        "bookings_title_pro": "Gestion des Réservations",
        "bookings_subtitle_client": "Consultez vos rendez-vous",
        "bookings_subtitle_pro": "Gérez vos rendez-vous clients",
        "status_pending": "En attente",
        "status_confirmed": "Confirmées",
        "status_revenue": "Prestations terminées",
        "filter_all": "Toutes",
        "filter_pending": "En attente",
        "filter_confirmed": "Confirmées",
        "filter_completed": "Terminées",
        "filter_cancelled": "Annulées",
        "badge_pending": "⏳ En attente",
        "badge_confirmed": "✓ Confirmée",
        "badge_completed": "✓ Terminée",
        "badge_cancelled": "✕ Annulée",
        "label_service": "Service",
        "label_date": "Date",
        "label_time": "Heure",
        "label_duration": "Durée",
        "label_price": "Prix",
        "promo_applied": "Promo appliquée",
        "label_notes": "Notes",
        "action_confirm": "Confirmer",
        "action_complete": "Terminer",
        "action_cancel": "Annuler",
        "action_delete": "Supprimer",
        "confirm_delete_booking": "Supprimer cette réservation ?",
        "no_bookings_title": "Aucune réservation",
        "no_bookings_desc": "Rien à afficher pour le moment.",
        "return_btn": "Retour",
        "pro_not_found": "Professionnel non trouvé",
        "default_pro_desc": "Bienvenue sur ma page de réservation.",
        "view_reviews": "Voir les avis",
        "services_title": "Prestations",
        "no_services": "Aucune prestation disponible.",
        "gallery_title": "Galerie",
        "booking_title": "Réservation",
        "label_select_service": "1. Prestation",
        "placeholder_select_service": "Sélectionner une prestation...",
        "label_select_date": "2. Date",
        "label_select_slot": "3. Créneau horaire",
        "loading_slots": "Chargement des créneaux...",
        "no_slots_available": "Aucun créneau disponible ce jour-là.",
        "total_label": "Total",
        "confirm_booking_btn": "Confirmer la réservation",
        "alert_login_required": "Veuillez vous connecter pour réserver",
        "alert_select_service": "Veuillez sélectionner un service",
        "alert_booking_success": "Réservation confirmée ! 🎉",
        "alert_booking_error": "Erreur lors de la réservation",
        "announcements_title": "Annonces & Promotions",
        "nav_announcements": "Annonces",
        "profile_name_required": "Le prénom et le nom sont obligatoires.",
        "profile_update_error": "Erreur lors de la mise à jour du profil.",
        "profile_update_success": "Profil mis à jour avec succès.",
        "network_error_retry": "Erreur réseau. Veuillez réessayer.",
        "delete_account_title": "Supprimer mon compte",
        "delete_account_message": "Cette action est irréversible. Toutes vos données (réservations, avis, photos) seront définitivement supprimées conformément à votre droit à l'effacement (RGPD art. 17).",
        "delete_account_confirm": "Supprimer définitivement",
        "delete_account_error": "Erreur lors de la suppression du compte.",
        "profile_edit_close": "Fermer l'édition",
        "profile_edit_open": "Modifier mon profil",
        "phone_label": "Téléphone",
        "profile_phone_placeholder": "Ex: +33 6 12 34 56 78",
        "saving": "Enregistrement...",
        "save_changes": "Enregistrer les modifications",
        "delete_my_account": "Supprimer mon compte",
        "not_available": "N/A",
        "pro_tab_overview": "Vue d'ensemble",
        "pro_tab_bookings": "Réservations",
        "pro_tab_planning": "Planning",
        "pro_tab_services": "Prestations",
        "pro_tab_reviews": "Avis Clients",
        "pro_tab_announcements": "Annonces",
        "pro_tab_profile": "Mon Profil",
        "pro_photos_added": "Photos ajoutées !",
        "pro_visuals_title": "Photos & Visuels",
        "pro_profile_photo": "Photo de profil",
        "pro_profile_photo_desc": "Apparaît sur votre fiche publique pour que les clients vous reconnaissent facilement.",
        "pro_gallery_title": "Galerie d'images (Salon & Réalisations)",
        "pro_add_photos": "Ajouter des photos",
        "pro_no_photos": "Aucune photo pour l'instant.",
        "pro_set_cover": "Définir comme couverture",
        "pro_cover_badge": "Couverture",
        "pro_cover_updated": "Photo de couverture mise à jour !",
        "pro_client_view": "Aperçu client",
        "pro_client_view_desc": "Voir votre page comme un client",
        "open_in_maps": "Ouvrir dans Maps",
        "pro_no_photos_desc": "Ajoutez des photos de votre espace ou de vos réalisations pour attirer plus de clients.",
        "pro_price_display_mode": "Affichage des prix",
        "pro_price_display_hint": "Choisissez comment vos prix apparaissent sur votre page publique.",
        "pro_price_display_exact": "Prix exacts",
        "pro_price_display_exact_desc": "Affiche le montant précis de chaque prestation.",
        "pro_price_display_tiers": "Tranches de prix",
        "pro_price_display_tiers_desc": "Affiche une gamme de prix (€ à €€€€).",
        "pro_price_display_hidden": "Masqués",
        "pro_price_display_hidden_desc": "Les prix ne sont pas affichés publiquement.",
        "pro_price_display_saved": "Affichage des prix mis à jour.",
        "pro_business_info": "Informations de l'établissement",
        "pro_company_public_name": "Mon Entreprise (Nom public)",
        "pro_company_placeholder": "Ex: Institut Beauté Plus",
        "pro_phone_number": "Numéro de Téléphone",
        "pro_phone_placeholder": "Ex: 01 23 45 67 89",
        "pro_full_address": "Adresse Complète",
        "pro_address_placeholder": "Ex: 10 Rue de Paris, 75001 Paris",
        "pro_opening_hours": "Horaires d'ouverture (Affichage libre)",
        "pro_opening_hours_placeholder": "Ex: Lundi-Vendredi 9h-18h, Samedi 9h-12h",
        "pro_description_expertise": "Description / Notre Expertise",
        "pro_description_placeholder": "Présentez votre établissement, votre équipe et votre savoir-faire en quelques lignes...",
        "public_preview": "Aperçu public",
        "pro_space": "ESPACE PRO",
        "pro_my_salon": "Mon Salon",
        "pro_mobile_header": "OpenGlow Pro",
        "pro_greeting": "Bonjour, {{name}}",
        "pro_overview_subtitle": "Voici un aperçu de votre activité.",
        "pro_revenue": "Prestations terminées",
        "pro_total_earned": "Prestations terminées",
        "pro_completed_services": "Prestations terminées",
        "pro_bookings": "Réservations",
        "pro_reviews_clients": "Avis Clients",
        "pro_based_on_reviews": "Basé sur vos avis",
        "pro_quick_actions": "Actions Rapides",
        "pro_manage_planning": "Gérer mon planning",
        "pro_my_services": "Mes prestations",
        "pro_need_help": "Besoin d'aide ?",
        "pro_help_text": "Consultez notre guide dédié pour améliorer l'attractivité de votre page et mieux gérer.",
        "pro_view_guide": "Voir le guide",
        "announcement_save_error": "Erreur lors de l'enregistrement",
        "announcement_delete_title": "Supprimer l'annonce",
        "announcement_delete_message": "Voulez-vous vraiment supprimer cette annonce ?",
        "announcements_subtitle": "Gérez vos offres spéciales et actualités pour attirer plus de clients.",
        "announcement_new": "Nouvelle annonce",
        "announcement_none_title": "Aucune annonce pour le moment",
        "announcement_none_desc": "Créez votre première annonce pour informer vos clients de vos promotions ou nouveautés.",
        "announcement_create": "Créer une annonce",
        "status_active": "Active",
        "status_inactive": "Inactive",
        "deactivate": "Désactiver",
        "activate": "Activer",
        "edit": "Modifier",
        "discount_label": "Remise",
        "from_label": "Du",
        "to_label": "au",
        "linked_service": "Service lié",
        "announcement_edit": "Modifier l'annonce",
        "announcement_title_label": "Titre de l'annonce",
        "announcement_title_placeholder": "Ex: Soldes d'été -20%",
        "label_description": "Description",
        "announcement_desc_placeholder": "Détails de votre offre...",
        "announcement_service_optional": "Prestation concernée (Optionnel)",
        "announcement_all_services": "-- Toutes les prestations --",
        "label_type": "Type",
        "type_promotion": "Promotion",
        "type_news": "Nouveauté",
        "type_event": "Événement",
        "type_other": "Autre",
        "announcement_discount_optional": "Remise (%) - Optionnel",
        "announcement_discount_placeholder": "Ex: 20",
        "start_date": "Date de début",
        "end_date_optional": "Date de fin (Optionnel)",
        "captcha_required": "Veuillez valider le CAPTCHA avant de continuer.",
        "account_not_verified_re_register": "Votre compte n'est pas vérifié. Veuillez vous réinscrire avec la même adresse e-mail pour recevoir un nouveau code.",
        "password_rules_error": "Le mot de passe ne respecte pas les critères de sécurité requis.",
        "must_be_adult": "Vous devez avoir au moins 15 ans pour vous inscrire.",
        "consent_required": "Veuillez accepter les conditions générales et la politique de confidentialité.",
        "valid_address_required": "Veuillez sélectionner une adresse valide dans la liste proposée.",
        "verification_code_invalid": "Code invalide ou expiré",
        "verify_email_title": "Vérifiez votre e-mail",
        "verify_email_message": "Nous avons envoyé un code à 6 chiffres à {{email}}. Entrez-le ci-dessous pour finaliser votre inscription.",
        "validate_account": "Valider mon compte",
        "edit_my_information": "Modifier mes informations",
        "business_address_label": "Adresse de l'établissement",
        "business_address_placeholder": "Saisissez une adresse complète...",
        "searching": "Recherche...",
        "register_consent_prefix": "J'ai lu et j'accepte les",
        "register_consent_terms": "Conditions Générales",
        "register_consent_and": "et la",
        "register_consent_policy": "Politique de Confidentialité",
        "register_consent_adult": "J'atteste avoir au moins 15 ans.",
        "admin_access_denied": "Accès refusé. Réservé aux administrateurs.",
        "admin_delete_user_title": "Supprimer cet utilisateur",
        "admin_delete_user_message": "Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.",
        "admin_user_deleted": "Utilisateur supprimé avec succès.",
        "admin_delete_error": "Erreur lors de la suppression.",
        "admin_title": "Administration",
        "admin_subtitle": "Monitorez et gérez les utilisateurs de la plateforme.",
        "admin_total_users": "TOTAL UTILISATEURS",
        "admin_clients": "CLIENTS",
        "admin_professionals": "PROFESSIONNELS",
        "admin_users_count": "Utilisateurs ({{count}})",
        "admin_name_email": "NOM / EMAIL",
        "admin_role": "ROLE",
        "admin_company": "ENTREPRISE",
        "admin_actions": "ACTIONS",
        "delete_booking_title": "Supprimer la réservation",
        "confirm_delete_booking_message": "Êtes-vous sûr de vouloir supprimer cette réservation ?",
        "confirm_accept_booking": "Confirmer ce rendez-vous ?",
        "confirm_booking_title": "Confirmer le rendez-vous",
        "complete_booking_title": "Terminer le rendez-vous",
        "confirm_complete_booking": "Marquer ce rendez-vous comme terminé ?",
        "cancel_booking_title": "Annuler le rendez-vous",
        "confirm_cancel_booking": "Êtes-vous sûr de vouloir annuler ce rendez-vous ?",
        "cancel_booking_confirm": "Annuler le RDV",
        "reviews_login_required": "Vous devez être connecté pour laisser un avis",
        "reviews_delete_confirm": "Supprimer cet avis ?",
        "reviews_leave": "Laisser un avis",
        "reviews_already_left": "Avis déjà laissé",
        "reviews_locked_title": "Avis indisponible pour le moment",
        "reviews_eligible_after_completed": "Vous pourrez laisser un avis après une prestation terminée avec ce salon.",
        "reviews_stats_title": "Statistiques des avis",
        "reviews_clients_count": "Avis clients ({{count}})",
        "reviews_none_title": "Aucun avis pour le moment",
        "reviews_none_desc": "Soyez le premier à partager votre expérience",
        "reviews_edit": "Modifier votre avis",
        "reviews_rating_label": "Note *",
        "rating_5": "Excellent",
        "rating_4": "Très bien",
        "rating_3": "Bien",
        "rating_2": "Moyen",
        "rating_1": "Décevant",
        "reviews_service_optional": "Prestation (optionnel)",
        "reviews_no_specific_service": "Aucune prestation spécifique",
        "reviews_comment": "Commentaire",
        "reviews_comment_placeholder": "Partagez votre expérience...",
        "reviews_update": "Mettre à jour",
        "reviews_publish": "Publier",
        "help_topic_profile_title": "Configurer mon profil",
        "help_topic_profile_desc": "Apprenez à mettre en valeur votre salon avec des photos, adresses, et informations d'ouverture.",
        "help_topic_services_title": "Gérer mes prestations",
        "help_topic_services_desc": "Ajouter, modifier ou désactiver les prestations disponibles pour vos clients.",
        "help_topic_planning_title": "Mon Planning & Réservations",
        "help_topic_planning_desc": "Comprendre où consulter vos prochains rendez-vous et comment les valider.",
        "help_topic_subscription_title": "Abonnement professionnel",
        "help_topic_subscription_desc": "Obtenez de l'aide concernant le passage à la version premium (facturation et avantages).",
        "help_faq_1_q": "J'ai oublié mon mot de passe, comment le réinitialiser ?",
        "help_faq_1_a": "Actuellement, veuillez contacter le support directement avec votre adresse e-mail professionnelle pour demander une réinitialisation manuelle.",
        "help_faq_2_q": "Les clients peuvent-ils réserver sans mon accord ?",
        "help_faq_2_a": "Par défaut, les clients peuvent réserver les créneaux disponibles. Vous serez notifié. Une option d'approbation manuelle arrivera prochainement.",
        "help_faq_3_q": "Comment supprimer une photo de mon salon ?",
        "help_faq_3_a": "Dans la version actuelle, vous pouvez téléverser de nouvelles photos. Pour archiver des anciennes, rendez-vous dans la console d'administration OpenGlow.",
        "help_title": "Bonjour, comment pouvons-nous aider ?",
        "help_search_placeholder": "Rechercher une question ou un thème...",
        "help_faq_title": "Questions fréquentes (FAQ)",
        "help_contact_title": "Vous ne trouvez pas votre réponse ?",
        "help_contact_desc": "Notre équipe support professionnel est disponible par e-mail.",
        "help_contact_cta": "Contacter le support",
        "map_title": "Carte des Professionnels",
        "map_nearby_count": "{{count}} salon à proximité",
        "map_nearby_count_plural": "{{count}} salons à proximité",
        "map_you_are_here": "Vous êtes ici",
        "map_google_maps": "Google Maps",
        "map_waze": "Waze",
        "map_apple_maps": "Plans (Apple)",
        "action_close": "Fermer",
        "not_found_title": "404 - Page non trouvée",
        "footer_navigation": "Navigation",
        "footer_pro_login": "Connexion Pro",
        "footer_legal": "Légal",
        "footer_about_us": "Qui sommes-nous",
        "footer_privacy": "Confidentialité",
        "footer_terms_short": "CGU",
        "country_france": "France",
        "quick_guide_title": "Guide d'utilisation",
        "quick_guide_header": "🚀 Guide rapide",
        "quick_guide_pro_step_1_title": "Complétez votre profil",
        "quick_guide_pro_step_1_desc": "Ajoutez vos informations, photo, et description de votre salon",
        "quick_guide_pro_step_2_title": "Ajoutez vos prestations",
        "quick_guide_pro_step_2_desc": "Créez vos services avec prix et durée dans l'onglet Prestations",
        "quick_guide_pro_step_3_title": "Ajoutez des photos",
        "quick_guide_pro_step_3_desc": "Mettez en valeur votre salon avec de belles photos",
        "quick_guide_pro_step_4_title": "Gérez vos réservations",
        "quick_guide_pro_step_4_desc": "Confirmez ou annulez les rendez-vous de vos clients",
        "quick_guide_pro_step_5_title": "Consultez vos statistiques",
        "quick_guide_pro_step_5_desc": "Suivez vos performances dans la page Réservations",
        "quick_guide_client_step_1_title": "Recherchez un professionnel",
        "quick_guide_client_step_1_desc": "Utilisez la page Recherche pour trouver votre salon",
        "quick_guide_client_step_2_title": "Consultez les prestations",
        "quick_guide_client_step_2_desc": "Découvrez les services et tarifs proposés",
        "quick_guide_client_step_3_title": "Réservez en ligne",
        "quick_guide_client_step_3_desc": "Choisissez votre prestation, date et heure",
        "quick_guide_client_step_4_title": "Gérez vos rendez-vous",
        "quick_guide_client_step_4_desc": "Consultez et annulez vos réservations si besoin",
        "cookie_banner_text": "Ce site utilise des cookies techniques nécessaires à son fonctionnement ainsi que",
        "cookie_recaptcha": "Google reCAPTCHA",
        "cookie_banner_recaptcha_suffix": "(données envoyées à Google pour la sécurité).",
        "cookie_learn_more": "En savoir plus",
        "action_decline": "Refuser",
        "action_accept": "Accepter",
        "email_required": "L'email est requis.",
        "forgot_password_link": "Mot de passe oublié ?",
        "forgot_password_title": "Récupération du mot de passe",
        "forgot_password_intro": "Entrez votre email pour recevoir un code de réinitialisation.",
        "send_reset_code": "Envoyer le code",
        "back_to_login": "Retour à la connexion",
        "reset_password_title": "Réinitialiser le mot de passe",
        "reset_password_intro": "Saisissez le code reçu par email et votre nouveau mot de passe.",
        "reset_code_label": "Code de réinitialisation",
        "new_password_label": "Nouveau mot de passe",
        "confirm_new_password_label": "Confirmer le nouveau mot de passe",
        "reset_password_btn": "Réinitialiser",
        "password_reset_request_success": "Si un compte existe, un code de réinitialisation a été envoyé.",
        "password_reset_request_error": "Erreur lors de l'envoi du code.",
        "reset_required_fields": "Tous les champs sont obligatoires.",
        "passwords_mismatch": "Les mots de passe ne correspondent pas.",
        "password_reset_error": "Erreur lors de la réinitialisation du mot de passe.",
        "password_reset_success": "Mot de passe réinitialisé avec succès.",
        "change_password_title": "Changer le mot de passe",
        "current_password_label": "Mot de passe actuel",
        "change_password_btn": "Mettre à jour le mot de passe",
        "password_change_success": "Mot de passe modifié avec succès.",
        "password_change_error": "Erreur lors du changement de mot de passe.",
        "settings_title": "Paramètres",
        "settings_back": "Retour",
        "settings_section_appearance": "Apparence",
        "settings_theme_intro": "Choisissez le thème de l'application.",
        "settings_theme_classic": "Noir & Blanc",
        "settings_theme_ocean": "Océan",
        "settings_theme_rose": "Rose",
        "settings_theme_dark": "Sombre",
        "settings_theme_night": "Night",
        "settings_compact_mode": "Mode compact",
        "settings_compact_mode_sub": "Réduit l'espacement de cette page",
        "settings_section_notifications": "Notifications",
        "settings_notif_email": "Emails de réservation",
        "settings_notif_email_sub": "Confirmations et rappels de rendez-vous",
        "settings_notif_push": "Centre de notifications",
        "settings_notif_push_sub": "Alertes dans l'application",
        "settings_notif_marketing": "Actualités & offres",
        "settings_notif_marketing_sub": "Nouveautés produit et promotions",
        "settings_section_account": "Compte",
        "settings_account_profile": "Profil",
        "settings_account_email_label": "Adresse e-mail",
        "settings_not_connected": "Non connecté",
        "settings_section_notifications": "Notifications",
        "settings_booking_sound_label": "Son pour les nouvelles demandes",
        "settings_booking_sound_hint": "Joue un son quand un client fait une demande de RDV.",
        "settings_sound_on": "Activé",
        "settings_sound_off": "Désactivé",
        "settings_sound_enable": "Activer le son",
        "settings_sound_disable": "Désactiver le son",
        "settings_section_security": "Sécurité",
        "settings_pwd_title": "Modifier le mot de passe",
        "settings_pwd_hint": "Choisissez un mot de passe fort (12+ car., maj., chiffre, symbole)",
        "settings_pwd_current": "Mot de passe actuel",
        "settings_pwd_new": "Nouveau mot de passe",
        "settings_pwd_confirm": "Confirmer le nouveau",
        "settings_pwd_submit": "Enregistrer le mot de passe",
        "settings_pwd_submitting": "Enregistrement…",
        "about_title": "Qui sommes-nous",
        "about_intro": "OpenGlow est une plateforme francaise qui simplifie la mise en relation entre clients et professionnels de la beaute.",
        "about_mission_title": "Notre mission",
        "about_mission_text": "Aider chaque personne a trouver rapidement un professionnel de confiance pres de chez elle, avec une experience de reservation simple, transparente et moderne.",
        "about_build_title": "Ce que nous construisons",
        "about_build_item_1": "Un espace client clair pour rechercher, reserver et suivre ses rendez-vous.",
        "about_build_item_2": "Un espace pro pour gerer planning, prestations, avis et annonces.",
        "about_values_title": "Nos valeurs",
        "about_values_simple_label": "Simplicite :",
        "about_values_simple_text": "une interface rapide a comprendre pour tous.",
        "about_values_trust_label": "Confiance :",
        "about_values_trust_text": "des informations claires et des profils verifies.",
        "about_values_respect_label": "Respect :",
        "about_values_respect_text": "protection des donnees personnelles et approche responsable.",
        "about_values_exigence_label": "Exigence :",
        "about_values_exigence_text": "amelioration continue de l'experience utilisateur.",
        "about_contact_title": "Contact",
        "about_contact_line_1": "Une question ou besoin d'aide ?",
        "about_contact_line_2": "Utilisez le chat interne du site pour une reponse plus rapide.",
        "about_contact_line_3": "Pour tout autre besoin, ecrivez-nous a",
        "settings_show_pwd": "Afficher",
        "settings_hide_pwd": "Masquer"
    }
}